export default "__VITE_ASSET__C25u$RXq__"